import baseUnits from './../visid/base-unit';

/*
  / Transforms unitless pixel value(s) to pxs
  / @access public
  / @param {Values} values - a value or collection of values
  / @return {pxs}
*/

export var pixify = function pixify() {
  var pxResult = '';
  for (var index = 0; index < arguments.length; index++) {
    var px = index < 0 || arguments.length <= index ? undefined : arguments[index];
    var currentPX = void 0;
    if (px === 0 || px === 'auto') {
      currentPX = px;
    } else {
      currentPX = px + 'px';
    }
    pxResult = pxResult + ' ' + currentPX;
  }
  return pxResult.trim();
};

/*
  / Transforms unitless pixel value(s) to ems off of `rootSizeUnit` variable
  / @access public
  / @param {Values} values - a value or collection of values
  / @return {ems}
*/

export var em = function em() {
  var emResult = '';
  for (var index = 0; index < arguments.length; index++) {
    var px = index < 0 || arguments.length <= index ? undefined : arguments[index];
    var currentEm = void 0;
    if (px === 0) {
      currentEm = '0';
    } else {
      currentEm = 1 / baseUnits.rootSizeUnit * px + 'em';
      currentEm = currentEm.replace(/^(-?)0+/, '$1'); // remove leading zero
    }
    emResult = emResult + ' ' + currentEm;
  }
  return emResult.trim();
};

/*
  / Transforms unitless pixel value(s) to rems `rootSizeUnit` variable
  / @access public
  / @param {Values} values - a value or collection of values
  / @return {rems}
*/

export var rem = function rem() {
  var remResult = '';
  for (var index = 0; index < arguments.length; index++) {
    var px = index < 0 || arguments.length <= index ? undefined : arguments[index];
    var currentRem = void 0;
    if (px === 0) {
      currentRem = '0';
    } else {
      currentRem = 1 / baseUnits.rootSizeUnit * px + 'rem';
      currentRem = currentRem.replace(/^(-?)0+/, '$1'); // remove leading zero
    }
    remResult = remResult + ' ' + currentRem;
  }
  return remResult.trim();
};